import { type ArtifactMetadata, FlightDeckClient } from '@atlassiansox/flight-deck-frontend-client';

import { type HydratorMap } from '../../utils/hydrator/types';
import { type ClientHandlers } from '../activity-client';

import BundledArtifact from './default-data/recent-work-service-artifact';

const RECENT_WORK_ARTIFACT = 'recent-work-service';
const FD_ENVIRONMENT = 'prod';

type HydratorConfig = {
	fragments: string;
	hydrators: Record<string, HydratorMap>;
};
type TranslatedEventTypes = {
	absolute: string;
	multiAbsolute: string;
	multiRelative: string;
	multiStandalone: string;
	relative: string;
	standalone: string;
};

export type TranslatedEventTypeMessages = Record<string, TranslatedEventTypes>;

export type FlightDeckConfig = {
	hydrators: Record<string, HydratorMap>;
	localization: {
		eventTypes: TranslatedEventTypeMessages;
	};
	queryFragments: string;
};

export const FD_CLIENT_FETCH_PROPS: ArtifactMetadata = {
	name: RECENT_WORK_ARTIFACT,
	dimensions: {
		environmentType: FD_ENVIRONMENT,
	},
};

export default class HydratorConfigClient {
	constructor(
		handlers: ClientHandlers,
		product?: string,
		private readonly artifactFetch?: () => Promise<FlightDeckConfig>,
	) {
		new FlightDeckClient(
			product || 'recent-work-client',
			{
				handlers,
			},
			[
				{
					name: 'recent-work-service',
					dimensions: {
						environmentType: FD_ENVIRONMENT,
					},
					value: BundledArtifact,
				},
			],
		);
		this.artifactFetch = artifactFetch;
	}

	private async fetchArtifact() {
		if (this.artifactFetch) {
			return BundledArtifact as FlightDeckConfig;
		}
		// We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
		// https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
		return BundledArtifact as FlightDeckConfig;
	}
	fetchConfig = async (): Promise<HydratorConfig> => {
		const artifact = await this.fetchArtifact();
		const { queryFragments: fragments, hydrators } = artifact;
		return {
			fragments,
			hydrators,
		};
	};
}
